<template>
  <div class="form-group lm-password" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      v-if="label"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }" class="position-relative wrapper-password">
      <input
        :value="value"
        @keyup.enter.exact="$emit('enter')"
        @input="$emit('input', $event.target.value)"
        @focusout="validateOnfocusOutMethod"
        class="form-control"
        :class="{'is-invalid': v.$error || serverErrorMessage }"
        :readonly="readonly"
        :placeholder="placeholder"
        :type="showInputValue ? 'text' : 'password'"
        :id="idComputed"
        :disabled="disabled"
        />
      <font-awesome-icon
        id="font-awesome-icon-eye"
        v-if="!showInputValue"
        icon="eye"
        size="sm"
        class="clickable eyes"
        @click="showInputValue = true"
        />
      <font-awesome-icon
        id="font-awesome-icon-eye-slash"
        v-if="showInputValue"
        icon="eye-slash"
        size="sm"
        class="clickable eyes"
        @click="showInputValue = false"
        />
      <p class="invalid-feedback" v-if="serverErrorMessage"> {{ $t('login_invalid_username_or_password') }} </p>
      <p class="invalid-feedback" v-if="v.sameAsNewPassword !== undefined && !v.sameAs">Las contraseñas no coinciden.</p>
      <p class="invalid-feedback" v-else-if="!v.isValid"> {{ $t('field_invalid')}} </p>
      <p class="invalid-feedback" v-else-if="!v.required"> {{ $t('field_required')}} </p>
      <p class="invalid-feedback" v-if="v.sameAs !== undefined && !v.sameAs"> {{ $t('field_same_as') + labelOfFieldUsedForsameAsValidation }}</p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  data () {
    return {
      showInputValue: false
    }
  },
  props: {
    serverErrorMessage: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.wrapper-password input {
  background-position: right calc(0.375em + 1.6875rem) center;
}

.wrapper-password .eyes {
  position: absolute;
  top: 13px;
  right: 13px;
  background: #fff;
  z-index: 1;
}

.wrapper-password::after {
  position: absolute;
  content: "";
  width: 27px;
  height: 27px;
  top: 2px;
  right: 2px;
  background: #fff;
  z-index: 0;
}
</style>
